import React from "react";
import maleProfileIcon from '../../Assets/maleProfileIcon.jpeg'
import femaleProfileIcon from '../../Assets/femaleProfileIcon.jpeg'
import { useTranslation } from "react-i18next";

function MemberCard({profileUrl,profileImage,type,onPress,isDetailed,...props}) {
  const { t, i18n } = useTranslation();
  let profileIcon=maleProfileIcon
  if(props.gender==='Female'){
    profileIcon=femaleProfileIcon
  }
  if(profileImage){
    profileIcon=profileImage
  }

  const colClass = isDetailed ? "w-full" : type === 'sm' ? "w-1/6" : "w-full md:w-1/4";
  const infoRows = [
    { label: 'Member ID', value: props.memberId },
    { label: 'Email', value: props.email },
    { label: 'Mobile', value: props.mobile },
    { label: 'Designation', value: props.memberDesignation },
    { label: 'Clan', value: props.clan },
    { label: 'Gender', value: props.gender },
    { label: 'Blood Group', value: props.bloodGroup },
    { label: 'Date of Birth', value: props.dob },
    { label: 'Address', value: [props.addressLine1, props.addressLine2, props.city, props.state, props.pinCode].filter(Boolean).join(', ') },
    { label: 'Higher Education', value: props.higherEducation },
    { label: 'Occupation', value: props.occupation },
    { label: 'Profession', value: props.profession },
  ].filter((row) => row.value);

  return (
    <div className={`${colClass} project-card`} onClick={profileUrl?onPress:()=>{}}>
      <div className="project-card-view">
        <img src={profileIcon} alt="No Image" className="w-full" />
        <div className="p-4">
          <h5 className="mainText font-semibold">{props.firstName} {props.middleName} {props.lastName}</h5>
          {props.memberDesignation && <h5>{t(props.memberDesignation)}</h5>}
          {type!=='sm' && <p style={{ textAlign: "justify" }}>{props.description}</p>}
          {type!=='sm' && (
            <p style={{ textAlign: "justify" }}>
              City : <span className="mainText">{props.city}</span>
            </p>
          )}
          {type!=='sm' && (
            <p style={{ textAlign: "justify" }}>
              {/* Occupation : <span className="mainText">{personalDetails.occupation}</span> */}
            </p>
          )}
          {isDetailed && (
            <div className="mt-4 space-y-2">
              {infoRows.map((row) => (
                <p key={row.label} className="text-sm" style={{ textAlign: "left" }}>
                  {row.label} : <span className="mainText">{row.value}</span>
                </p>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
export default MemberCard;
